import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_warehouse_inventory_analytics, loading_retrieve_warehouse_inventory_analytics, reset_retrieve_warehouse_inventory_analytics, success_retrieve_warehouse_inventory_analytics } from '../../../../reducers/auth_tenant/retrieve_warehouse_inventory_analytics_Slice';
import { RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_API } from '../../../../api/api_data';
import { RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_ERROR_MSG, RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import * as app_consts from "../../../../utils/app_consts";
import { formatNumber, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import { Block, BlockHead, BlockHeadContent, Button, Col, Icon, Row } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { Card } from 'reactstrap';
import { useSelector } from 'react-redux';
import { Pie } from 'react-chartjs-2';

const WarehouseInventoryAnalyticsData = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [page_data, setPageData] = useState();
 const [adjustment_labels, setAdjustmentLabels] = useState([]);
 const [adjustment_values, setAdjustmentValues] = useState([]);

 const dispatch = useDispatch();

 useEffect(() => {
  retrive_warehouse_inventory_analytics();
 }, []);

 const retrive_warehouse_inventory_analytics = () => {
  setError("");
  setLoading(true);
  dispatch(tenant_auth_actions_helper(loading_retrieve_warehouse_inventory_analytics, success_retrieve_warehouse_inventory_analytics, fail_retrieve_warehouse_inventory_analytics, RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_ERROR_MSG, RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_API}`));
 };

 // Listen
 const retrieve_warehouse_inventory_analytics_listener = useSelector((state) => state.retrieve_warehouse_inventory_analytics.retrieve_warehouse_inventory_analytics);

 useEffect(() => {
  if (retrieve_warehouse_inventory_analytics_listener.status !== app_consts.IDLE)
  {
   if (retrieve_warehouse_inventory_analytics_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_warehouse_inventory_analytics_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_warehouse_inventory_analytics_listener.message);
     messageToast(retrieve_warehouse_inventory_analytics_listener.message, app_consts.FAIL);
    } else if (retrieve_warehouse_inventory_analytics_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_warehouse_inventory_analytics_listener.data);
     setAdjustmentLabels(retrieve_warehouse_inventory_analytics_listener.data?.adjustments_count?.map((stat) => formatToSentenceCase(stat?.label)));
     setAdjustmentValues(retrieve_warehouse_inventory_analytics_listener.data?.adjustments_count?.map((stat) => stat?.value));
     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_warehouse_inventory_analytics());
   }
  }
 }, [retrieve_warehouse_inventory_analytics_listener]);

 const adjustment_piechart_data = {
  labels: adjustment_labels,
  datasets: [{
   data: adjustment_values,
   backgroundColor: ["#6576ff", "#e3e7fe", "#8e9dff", "#b1bcff", "#d0d7ff"],
   borderWidth: 0
  }]
 };

 const pieOptions = {
  plugins: {
   legend: {
    position: 'bottom',
    labels: {
     usePointStyle: true,
     padding: 20,
     font: {
      family: "'Inter', sans-serif",
      size: 12
     }
    }
   },
   tooltip: {
    callbacks: {
     label: function (context) {
      const label = context.label || '';
      const value = context.raw || 0;
      const total = context.dataset.data.reduce((a, b) => a + b, 0);
      const percentage = Math.round((value / total) * 100);
      return `${label}: ${value} (${percentage}%)`;
     }
    }
   }
  },
  cutout: '70%',
  maintainAspectRatio: false
 };


 return (
  <>
   <div style={{ padding: '0 15px' }} className='mt-4'>
    <BlockHead size="sm">
     <BlockHeadContent style={{ marginBottom: '20px' }}>
      <h4 style={{ marginBottom: '5px', fontWeight: '600', color: '#1a1a1a' }}>Warehouse Inventory Analytics</h4>
     </BlockHeadContent>
     {!loading && (
      <div style={{ marginTop: '8px' }}>
       <Link onClick={(e) => { e.preventDefault(); retrive_warehouse_inventory_analytics(); }}>
        <Button color="light" outline style={{ backgroundColor: 'white', display: 'inline-flex', alignItems: 'center' }}>
         <span>Refresh</span>
        </Button>
       </Link>
      </div>
     )}
    </BlockHead>

    {loading ? (
     <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Warehouse Analytics..." />
    ) : error ? (
     <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
    ) : (
     <Block style={{ marginTop: '20px' }}>
      <Row className="g-gs" style={{ marginBottom: '20px' }}>
       {/* Stats Cards */}
       <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
        <Card style={{
         borderRadius: '8px',
         border: '1px solid #e5e9f2',
         transition: 'all 0.3s ease',
         marginBottom: 0,
         height: '100%',
         ':hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transform: 'translateY(-2px)'
         }
        }}>
         <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <div>
            <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Current Balance</h6>
            <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{formatNumber(page_data?.total_inventory_balance || "0")} Units</h2>
           </div>
           <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            backgroundColor: 'rgba(101, 118, 255, 0.1)'
           }}>
            <Icon name="box" style={{ color: '#6576ff' }}></Icon>
           </div>
          </div>
         </div>
        </Card>
       </Col>
       <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
        <Card style={{
         borderRadius: '8px',
         border: '1px solid #e5e9f2',
         transition: 'all 0.3s ease',
         marginBottom: 0,
         height: '100%',
         ':hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transform: 'translateY(-2px)'
         }
        }}>
         <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <div>
            <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Stock In</h6>
            <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{formatNumber(page_data?.total_units_added || "0")} Units</h2>
           </div>
           <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            backgroundColor: 'rgba(101, 118, 255, 0.1)'
           }}>
            <Icon name="box" style={{ color: '#6576ff' }}></Icon>
           </div>
          </div>
         </div>
        </Card>
       </Col>
       <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
        <Card style={{
         borderRadius: '8px',
         border: '1px solid #e5e9f2',
         transition: 'all 0.3s ease',
         marginBottom: 0,
         height: '100%',
         ':hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transform: 'translateY(-2px)'
         }
        }}>
         <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <div>
            <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Stock Out</h6>
            <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{formatNumber(page_data?.total_units_subtracted) || "0"} Units</h2>
           </div>
           <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            backgroundColor: 'rgba(101, 118, 255, 0.1)'
           }}>
            <Icon name="box" style={{ color: '#6576ff' }}></Icon>
           </div>
          </div>
         </div>
        </Card>
       </Col>
       <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
        <Card style={{
         borderRadius: '8px',
         border: '1px solid #e5e9f2',
         transition: 'all 0.3s ease',
         marginBottom: 0,
         height: '100%',
         ':hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transform: 'translateY(-2px)'
         }
        }}>
         <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <div>
            <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Warehouses (With Inventory)</h6>
            <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.inventory_warehouse_site_count?.length || "0"}</h2>
           </div>
           <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            backgroundColor: 'rgba(101, 118, 255, 0.1)'
           }}>
            <Icon name="box" style={{ color: '#6576ff' }}></Icon>
           </div>
          </div>
         </div>
        </Card>
       </Col>
       <Col xxl="3" md="6" style={{ marginBottom: '20px' }}>
        <Card style={{
         borderRadius: '8px',
         border: '1px solid #e5e9f2',
         height: '100%',
         overflow: 'hidden'
        }}>
         <div style={{ padding: '20px' }}>
          <div style={{ marginBottom: '16px' }}>
           <h6 style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>Inventory Distribution</h6>
          </div>
          <div style={{ height: '200px', position: 'relative', marginBottom: '16px' }}>
           <Pie data={adjustment_piechart_data} options={pieOptions} />
          </div>
          <div style={{ marginTop: '12px' }}>
           {page_data?.status_count?.map((stat, index) => (
            <div key={index} style={{
             display: 'flex',
             alignItems: 'center',
             marginBottom: '8px',
             fontSize: '14px'
            }}>
             <span style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              marginRight: '8px',
              backgroundColor: adjustment_piechart_data.datasets[0].backgroundColor[index]
             }}></span>
             <span style={{ flex: 1 }}>{formatToSentenceCase(stat?.label) || "--"}</span>
             <span style={{ fontWeight: '500' }}>{stat?.value || 0}</span>
            </div>
           ))}
          </div>
         </div>
        </Card>
       </Col>
      </Row>
     </Block>
    )
    }


   </div>
  </>
 );
};

export default WarehouseInventoryAnalyticsData;